<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="required" v-if="isMandatory">*</span>
        <span class="label">违章处理</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')" v-if="!isMandatory"></i>
      </div>
      <div class="desc">承租人需自行处理车辆租赁期间的违章。若还车时未处理，需交处理费。</div>
    </div>
    <div class="ai-box" v-if="tip">
      <span class="ai-tag">AI</span>
      <span class="ai-text">{{ tip }}</span>
    </div>
    <div class="rule-body">
      <div style="width: 100%;">
        <div class="radio-row">
          <span class="label-text" style="margin-right: 10px;">有扣分</span>
          <el-form-item :prop="`${propPrefix}.pointFeePerScore`" :rules="getRules(1000)" class="flex-input" style="margin-bottom: 0;">
            <el-input
              :value="modelValue.pointFeePerScore"
              placeholder="请输入"
              size="small"
              v-number:float
              @input="updateField('pointFeePerScore', $event)">
              <template slot="append">元/每分</template>
            </el-input>
          </el-form-item>
          <span class="separator">+</span>
          <el-form-item :prop="`${propPrefix}.overdueFeeWithDeduction`" :rules="getRules(1000)" class="flex-input with-prefix" style="margin-left: 8px; margin-bottom: 0;">
            <el-input
              :value="modelValue.overdueFeeWithDeduction"
              placeholder="请输入"
              size="small"
              v-number:float
              @input="updateField('overdueFeeWithDeduction', $event)"
            >
              <template slot="prepend">处理费</template>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
        <div class="radio-row" style="margin-top: 30px;">
          <span class="label-text" style="margin-right: 10px;">无扣分</span>
          <el-form-item :prop="`${propPrefix}.overdueFeeWithoutDeduction`" :rules="getRules(1000)" class="flex-input single with-prefix" style="margin-bottom: 0;">
            <el-input
              :value="modelValue.overdueFeeWithoutDeduction"
              placeholder="请输入"
              size="small"
              v-number:float
              @input="updateField('overdueFeeWithoutDeduction', $event)"
            >
              <template slot="prepend">处理费</template>
              <template slot="append">元/每次</template>
            </el-input>
          </el-form-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getRules } from './utils'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
  isMandatory: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
::v-deep .with-prefix {
  .el-form-item__error {
    margin-left: 83px;
  }
}
</style>
